export type NavItem = {
  href: string;
  heading: string;
  description: string;
  icon: "army" | "changelog" | "help";
};

export const navItems: NavItem[] = [
  {
    href: "~/army",
    icon: "army",
    heading: "Army Builder",
    description: "Build and share your armies.",
  },

  {
    href: "~/changelog",
    icon: "changelog",
    heading: "Changelog",
    description: "Learn what's new.",
  },

  {
    href: "~/help",
    icon: "help",
    heading: "Help",
    description: "Get help with the app.",
  },
];
